var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.12 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n      .cls-2 {\n        fill: #022133;\n      }\n      .cls-3 {\n        fill: #00ac6a;\n      }\n      .rotate-o {\n        animation: rotateO 1s linear infinite;\n        ", "\n        transform-origin: 505px 178.44px;\n      }\n      @keyframes rotateO {\n        0% {\n          transform: rotate(0deg);\n        }\n        100% {\n          transform: rotate(360deg);\n        }\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0h202C411.73,0,582,170.27,582,380h0c0,209.73-170.27,380-380,380H0V0h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "rotate-o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505,178.44c-47.1,0-85.28-38.18-85.28-85.28S457.9,7.88,505,7.88v170.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505,349c47.1,0,85.28-38.18,85.28-85.28s-38.18-85.28-85.28-85.28v170.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.12,178c0-47.1-38.18-85.28-85.28-85.28-47.1,0-85.28,38.18-85.28,85.28h170.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.56,178c0,47.1-38.18,85.28-85.28,85.28-47.1,0-85.28-38.18-85.28-85.28h170.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d5da67c88f10e5a1f492167a255481a9.svg";
export { ForwardRef as ReactComponent };